/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChoreographerListItem } from './ChoreographerListItem';
import {
    ChoreographerListItemFromJSON,
    ChoreographerListItemFromJSONTyped,
    ChoreographerListItemToJSON,
    ChoreographerListItemToJSONTyped,
} from './ChoreographerListItem';

/**
 * 
 * @export
 * @interface ResultOfIReadOnlyListOfChoreographerListItem
 */
export interface ResultOfIReadOnlyListOfChoreographerListItem {
    /**
     * 
     * @type {Array<ChoreographerListItem>}
     * @memberof ResultOfIReadOnlyListOfChoreographerListItem
     */
    data: Array<ChoreographerListItem> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResultOfIReadOnlyListOfChoreographerListItem
     */
    isSuccess: boolean;
    /**
     * 
     * @type {Error}
     * @memberof ResultOfIReadOnlyListOfChoreographerListItem
     */
    error: Error | null;
}

/**
 * Check if a given object implements the ResultOfIReadOnlyListOfChoreographerListItem interface.
 */
export function instanceOfResultOfIReadOnlyListOfChoreographerListItem(value: object): value is ResultOfIReadOnlyListOfChoreographerListItem {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function ResultOfIReadOnlyListOfChoreographerListItemFromJSON(json: any): ResultOfIReadOnlyListOfChoreographerListItem {
    return ResultOfIReadOnlyListOfChoreographerListItemFromJSONTyped(json, false);
}

export function ResultOfIReadOnlyListOfChoreographerListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfIReadOnlyListOfChoreographerListItem {
    if (json == null) {
        return json;
    }
    return {
        
        'data': (json['data'] == null ? null : (json['data'] as Array<any>).map(ChoreographerListItemFromJSON)),
        'isSuccess': json['isSuccess'],
        'error': json['error'],
    };
}

export function ResultOfIReadOnlyListOfChoreographerListItemToJSON(json: any): ResultOfIReadOnlyListOfChoreographerListItem {
    return ResultOfIReadOnlyListOfChoreographerListItemToJSONTyped(json, false);
}

export function ResultOfIReadOnlyListOfChoreographerListItemToJSONTyped(value?: ResultOfIReadOnlyListOfChoreographerListItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': (value['data'] == null ? null : (value['data'] as Array<any>).map(ChoreographerListItemToJSON)),
        'isSuccess': value['isSuccess'],
        'error': value['error'],
    };
}

